module.exports = __webpack_public_path__ + "6e19a1327457dedc7eb3280995dd5187.jpg";